import React, { useRef, useEffect } from 'react';
import { Logger } from '../tools/logger';
import './VideoComponent.scss'
import { StreamManager } from 'openvidu-browser';

const console = new Logger('VideoComponent')

export class StreamHelper {
  /**
   * @param {StreamManager} streamManager 
   * @param {string} defaultName 
   */
  constructor(streamManager, defaultName = 'User') {
    this.streamManager = streamManager
    this.defaultName = defaultName
  }

  getData() {
    try {
      /** @type {string} */
      const connectionData = this.streamManager?.stream?.connection?.data;
      if (!connectionData) {
        return {}
      }
      const [clientData] = connectionData.split('%/%')
      return JSON.parse(clientData)
    } catch (e) {
      const error = { message: e.message, object: this.streamManager?.stream?.connection?.data }
      console.warn('Could not parse connection data', JSON.stringify(error, null, 2))
    }
    return {}
  }

  getInfo() {
    try {
      const stream = this.streamManager?.stream;
      if (!stream) {
        return {}
      }
      return {
        audioActive: stream.audioActive,
        videoActive: stream.videoActive,
        streamId: stream.streamId,
        creationTime: stream.creationTime ? new Date(stream.creationTime).toISOString() : undefined,
      }
    } catch (e) {
      console.log('error', e.message)
      return {}
    }
  }

  getDisplayName() {
    const data = this.getData()
    return data.clientData || data.name || this.defaultName
  }

  isScreenShare() {
    const data = this.getData()
    return data.mediaSource === 'screen'
  }
}


/**
 * 
 * @param {{
 *  streamManager: StreamManager
 * }} param0 
 * @returns 
 */
export const VideoComponent = React.memo(({ streamManager, isPublisher = false, isMobile = false }) => {
  const videoRef = useRef();

  useEffect(() => {
    if (streamManager && videoRef.current) {
      streamManager.addVideoElement(videoRef.current);
    }
  }, [streamManager]);
  const helper = new StreamHelper(streamManager)

  const styles = {
    container: {
      position: 'relative',
      borderRadius: isMobile ? '12px' : '8px',
      overflow: 'hidden',
      margin: isMobile ? '8px' : '10px',
      background: '#000',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
    publisherContainer: {
      width: isMobile ? '100%' : '300px',
      height: isMobile ? '200px' : '200px',
      border: helper.isScreenShare() ? '3px solid #ff6b35' : '3px solid #007bff',
    },
    subscriberContainer: {
      width: isMobile ? 'calc(50% - 16px)' : '250px',
      height: isMobile ? '150px' : '150px',
      border: '2px solid #28a745',
    },
    video: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      background: '#000',
    },
    nameTag: {
      position: 'absolute',
      bottom: '8px',
      left: '8px',
      background: 'rgba(0,0,0,0.7)',
      color: 'white',
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: isMobile ? '12px' : '14px',
      fontWeight: '500',
      backdropFilter: 'blur(10px)',
    },
    screenShareBadge: {
      position: 'absolute',
      top: '8px',
      left: '8px',
      background: 'rgba(255,107,53,0.9)',
      color: 'white',
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '10px',
      fontWeight: '600',
    },
    audioMutedBadge: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      background: 'rgba(220,53,69,0.9)',
      color: 'white',
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '10px',
    }
  };

  const cls = (...classes) => classes.join(' ')
  return (
    <div
      className={cls('video-container', isPublisher ? 'publisher' : 'subscriber')}
    >
      <video
        ref={videoRef}
        autoPlay={true}
        muted={isPublisher}
        style={styles.video}
        playsInline
      />

      {/* <div style={styles.nameTag}>
        {helper.getDisplayName()} {isPublisher ? '(You)' : ''}
      </div>

      {helper.isScreenShare() && (
        <div style={styles.screenShareBadge}>
          🖥️ Screen
        </div>
      )}

      {streamManager?.stream?.audioActive === false && (
        <div style={styles.audioMutedBadge}>
          🔇 Muted
        </div>
      )} */}
    </div>
  );
});
